import { render, staticRenderFns } from "./RadioComp.vue?vue&type=template&id=79812d60&"
import script from "./RadioComp.vue?vue&type=script&lang=js&"
export * from "./RadioComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports